import React, { useEffect, useRef } from "react";

export const GradientRange = ({
  rangeValue,
  onChange,
  rangeName,
  classNames = "",
}) => {
  const rangeRef = useRef();

  const progressScript = () => {
    if (rangeRef.current) {
      const sliderValue = rangeRef.current.value;
      rangeRef.current.style.background = `linear-gradient(to right, var(--gradient-left) 0%, var(--gradient-right) ${sliderValue}%, var(--white-10) ${sliderValue}%)`;
    }
  };

  useEffect(() => {
    progressScript();
  }, [rangeValue]);

  return (
    <div className={`gradient-range ${classNames}`}>
      <input
        ref={rangeRef}
        type="range"
        value={rangeValue}
        className="range"
        name={rangeName}
        onChange={(e) => {
          onChange(e);
        }}
      />
    </div>
  );
};
